"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnBlacklistButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const utils_1 = require("../../../utils");
const dialog_1 = require("./dialog");
const UnBlacklistButton = (props) => {
    const { className, contract, contract: { address, contractFeatures, accessControls }, disabled, variant, } = props;
    const [isUnBlacklistDialogOpen, setIsUnBlacklistDialogOpen] = (0, react_1.useState)(false);
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE);
    const handleUnBlacklist = () => {
        setIsUnBlacklistDialogOpen(true);
    };
    const handleUnBlacklistCancel = () => {
        setIsUnBlacklistDialogOpen(false);
    };
    const handleUnBlacklistConfirm = () => {
        setIsUnBlacklistDialogOpen(false);
    };
    if (!contractFeatures.includes(types_1.ContractFeatures.BLACKLIST)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUnBlacklist, icon: icons_material_1.DoNotDisturbOff, message: "form.buttons.unblacklist", className: className, dataTestId: "UnBlacklistButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || !hasPermission, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.AccessListUnBlacklistDialog, { onCancel: handleUnBlacklistCancel, onConfirm: handleUnBlacklistConfirm, open: isUnBlacklistDialogOpen, data: { address } })] }));
};
exports.UnBlacklistButton = UnBlacklistButton;
//# sourceMappingURL=index.js.map